import { createUserManager } from 'redux-oidc';
// import { WebStorageStateStore } from 'oidc-client';

let client_id;
let scopes;
let authority;
switch(process.env.REACT_APP_ENV) {
  default:
  case 'development':
    client_id = 'attivazione-online-mobility';
    scopes = 'user_info apiu400 api-localization';
    authority = 'https://test-auth-emobility.dufercoenergia.com';
    break;
  case 'test':
    client_id = 'attivazione-online-mobility';
    scopes = 'user_info apiu400 api-localization';
    authority = 'https://test-auth-emobility.dufercoenergia.com';
    break;
  case 'staging':
    client_id = 'attivazione-online-mobility';
    scopes = 'user_info apiu400 api-localization';
    authority = 'https://test-auth-emobility.dufercoenergia.com';
    break;
  case 'production':
    client_id = 'attivazione-online-mobility';
    scopes = 'user_info apiu400 api-localization';
    authority = 'https://auth-emobility.dufercoenergia.com';
    break;
}

const userManagerConfig = {
  client_id,
  redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/callback`,
  post_logout_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/`,
  response_type: 'token id_token',
  scope: 'openid profile email '+ scopes,
  authority,
  monitorSession: false, //evita di utilizzare i cookie di sessione forniti dall'identity server
  automaticSilentRenew: true,
  //il silent_redirect_uri deve essere impostato nella lista di redirect_uris consentiti lato Identity Server
  silent_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/silent_renew`,
  // filterProtocolClaims: true, // from Docs: "Should OIDC protocol claims be removed from profile"
  // loadUserInfo: true, // Di default salva (e con questa opzione carica) i dati su sessionStorage, ma noi già lo salviamo su localStorage
  // userStore: new WebStorageStateStore({ store: window.localStorage })
};

const userManager = createUserManager(userManagerConfig);
export default userManager;
